var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.4 23.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#8c8c8c;}.cls-2{clip-rule:evenodd;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-3);}.cls-7{clip-path:url(#clippath-2);}.cls-8{isolation:isolate;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 20.4,
    height: 23.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: -1,
    width: 21,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.3,2.8c-3.3,.8-5.7,3.8-5.7,7.4v5.1c0,.5-.4,.9-.8,.9-.9,0-1.7,.8-1.7,1.7s.8,1.7,1.7,1.7H18.7c.9,0,1.7-.8,1.7-1.7s-.8-1.7-1.7-1.7-.8-.4-.8-.9v-5.1c0-3.6-2.4-6.6-5.7-7.4v-.9C12.1,.9,11.3,0,10.2,0s-1.9,.9-1.9,1.9v.9Zm-1.1,17.6h6c0,1.6-1.3,3-3,3s-3-1.3-3-3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 21,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -5,
    y: -5,
    width: 30.4,
    height: 33.4
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.c41b99bbeaa049b10feeb7e9f7e786c2.svg";
export { ForwardRef as ReactComponent };